import { useCallback } from 'react';
import {
  setAuth as onSetAuth,
  logout as onLogout,
  setMyProfile as onSetMyProfile,
} from '@/store/auth/admin';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { IAuth, IProfile } from '@/types';
import { RootState } from 'src/store';

function useAuth() {
  const state = useAppSelector((state: RootState) => state.auth);

  const dispatch = useAppDispatch();

  const setAuth = useCallback((iAuth: IAuth) => {
    dispatch(onSetAuth(iAuth));
  }, []);

  const setMyProfile = useCallback((myProfile: IProfile) => {
    dispatch(onSetMyProfile(myProfile));
  }, []);

  const logout = useCallback(() => {
    dispatch(onLogout());
  }, []);

  return {
    auth: state?.auth || null,
    myProfile: state?.myProfile || null,
    isSuperAdmin: state?.myProfile?.role == 'SUPER_ADMIN',
    isAdmin: state?.myProfile?.role == 'ADMIN',
    setAuth,
    logout,
    setMyProfile,
  };
}

export { useAuth };
